// extracted by mini-css-extract-plugin
export default {"button":"scrollTopButton_button__8ZhU5","visible":"scrollTopButton_visible__4etuA"};